module.exports = __webpack_public_path__ + "images/Terminal.87e8a2cfcb4e2e83998f8c715ce606dd.svg";